import { useFlags } from 'launchdarkly-react-client-sdk';
import { graphql } from 'src/gql';

import { useQueryWithErrorLogging } from '@savvy/graphql-hooks/useQueryWithErrorLogging';

import { INBOX_ALERT_TYPES } from '../constants';

export const notificationRoutingQuery = graphql(/* GraphQL */ `
  query NotificationRouting($userId: ID!) {
    notificationRouting(userId: $userId) {
      alertType
      destination
    }
  }
`);

export function useInboxAlertTypes(userId: string) {
  const flags = useFlags();
  const notificationsV2 = Boolean(flags['flagNotificationsV2']);
  const { data, loading, error } = useQueryWithErrorLogging(notificationRoutingQuery, {
    variables: { userId },
    skip: !notificationsV2,
  });

  const routing = data?.notificationRouting;
  if (!notificationsV2 || loading || error !== undefined || routing === undefined || routing.length === 0) {
    return INBOX_ALERT_TYPES;
  }

  const catalogTypes: ReadonlySet<string> = new Set(routing.map((route) => route.alertType));
  const legacyInboxTypes = INBOX_ALERT_TYPES.filter((alertType) => !catalogTypes.has(alertType));
  const catalogInboxTypes = routing.filter((route) => route.destination === 'inbox').map((route) => route.alertType);

  return [...legacyInboxTypes, ...catalogInboxTypes];
}
